/**
 * allow upload file with these types
 * */
export const allowedFileTypesToUpload = [
  "image/*",
  "video/*",
  "audio/*",
  "application/pdf",
  ".docx",
  ".MTS",
  ".mts",
  ".m4v",
  ".M4V",
  ".vob",
  ".VOB",
  ".avi",
  ".AVI",
  ".mkv",
  ".MKV"
] as const;

export const mediaUploadAcceptTypes = [
  ".jpg",
  ".jpeg",
  ".png",
  ".gif",
  ".webp",
  ".bmp",
  ".svg",
  ".avif",
  ".ico",
  "video/*",
  "audio/*",
  "application/pdf",

  ".docx",
  ".MTS",
  ".mts",
  ".m4v",
  ".M4V",
  ".vob",
  ".VOB",
  ".avi",
  ".AVI",
  ".mkv",
  ".MKV"
] as const;

export const mediaUploadAccept = mediaUploadAcceptTypes.join(", ");
